import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackPrescriptionHomeWithPatientsView = (userId?: string): void => {
  trackingService.trackEvent(
    'BEGIN',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '/inicio',
      placement: '',
      surface: '',
      flow: 'inicio',
      step: 'com pacientes',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackNewPatientClick = (userId?: string): void => {
  trackingService.trackEvent(
    'REGISTER',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: '',
      flow: 'cadastro paciente',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackImportPatientsClick = (userId?: string): void => {
  trackingService.trackEvent(
    'IMPORT',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: '',
      flow: 'importar pacientes',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientCardClick = (userId?: string, patientId?: string): void => {
  trackingService.trackEvent(
    'PACIENT',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'card',
      flow: 'prescrever',
      step: 'selecionar paciente',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      patient_id: patientId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientEditClick = (userId?: string, patientId?: string): void => {
  trackingService.trackEvent(
    'EDIT',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'card',
      flow: 'cadastro paciente',
      step: 'editar paciente',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      patient_id: patientId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientDeleteClick = (userId?: string, patientId?: string): void => {
  trackingService.trackEvent(
    'REMOVE',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'card',
      flow: 'remover paciente',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      patient_id: patientId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientDeleteCancelClick = (userId?: string, patientId?: string): void => {
  trackingService.trackEvent(
    'CANCEL',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'remover paciente',
      step: 'cancelar',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      patient_id: patientId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientDeleteConfirmClick = (userId?: string, patientId?: string): void => {
  trackingService.trackEvent(
    'REMOVE',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: 'dialog',
      flow: 'remover paciente',
      step: 'confirmar',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      patient_id: patientId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPatientNotFoundRegisterClick = (userId?: string): void => {
  trackingService.trackEvent(
    'REGISTER',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'main',
      surface: '',
      flow: 'cadastro paciente',
      step: 'CPF não encontrado',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
